"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.USER_LOGOUT = void 0;
var _default = exports.default = {
  INVALID_USERNAME: 2,
  INVALID_PASSWORD: 5,
  PASSWORD_FORCED_EXPIRED: 12,
  PASSWORD_EXPIRED: 13,
  LOCKED: 14,
  OTHER_DATACENTER: 16,
  ALREADYLOGGEDIN: 1000,
  DEACTIVATED: 10,
  ETSC_DISABLED: 'ETSC-101',
  INVALIDDEEPLINKURL: '2000',
  MFA_REQUIRED: 41,
  MFA_INVALID: 42,
  MFA_ENROLL: 43,
  PASSWORD_POLICY_FAILURE: 139
};
var USER_LOGOUT = exports.USER_LOGOUT = '@@nui-auth/USER_LOGOUT';